export default __webpack_public_path__ + "static/media/guide_icon.f4e4f293.svg";